module.exports = __webpack_public_path__ + "static/media/Schritt_1_Gespraech_mit_Torben_Teller.991a5f2a.pdf";